import { render, staticRenderFns } from "./Poh-Dashboard.vue?vue&type=template&id=98c16d9a&scoped=true&"
import script from "./Poh-Dashboard.vue?vue&type=script&lang=js&"
export * from "./Poh-Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Poh-Dashboard.vue?vue&type=style&index=0&id=98c16d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c16d9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCardSubtitle,VCardTitle,VCol,VContainer,VDialog,VImg,VRow})
